import React from "react";
import { CheckCircle2, Clock, AlertTriangle, XCircle, Lock, Pause, Ban } from "lucide-react";

const STATE_STYLES = {
  draft: { c: "border-border bg-muted text-muted-foreground", I: Pause, label: "Draft" },
  active: { c: "border-status-info/40 bg-status-info/10 text-status-info", I: Lock, label: "Active" },
  fulfilled: { c: "border-status-ok/40 bg-status-ok/10 text-status-ok", I: CheckCircle2, label: "Fulfilled" },
  cancelled: { c: "border-border bg-muted text-muted-foreground", I: Ban, label: "Cancelled" },
  disputed: { c: "border-amber-500/40 bg-amber-500/10 text-amber-600 dark:text-amber-400", I: AlertTriangle, label: "Disputed" },
  refunded: { c: "border-border bg-muted text-foreground", I: Clock, label: "Refunded" },
  expired: { c: "border-border bg-muted text-muted-foreground", I: Clock, label: "Expired" },
  blocked: { c: "border-status-tampered/40 bg-status-tampered/10 text-status-tampered", I: XCircle, label: "Blocked" },
};

export default function ContractStateBadge({ state, size = "sm" }) {
  const s = STATE_STYLES[state] || STATE_STYLES.draft;
  const I = s.I;
  const padding = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-0.5 text-[11px]";
  return (
    <span data-testid={`contract-state-${state}`} className={`inline-flex items-center gap-1.5 ${padding} border rounded-sm font-medium ${s.c}`}>
      <I className={size === "lg" ? "w-4 h-4" : "w-3 h-3"} strokeWidth={1.5} />
      {s.label}
    </span>
  );
}
